const createMemoryStorage = () => {
  let data: Record<string, string> = {};

  return {
    getItem(key: string): string | null {
      return data[key] ?? null;
    },
    setItem(key: string, value: string): void {
      data[key] = value.toString();
    },
    removeItem(key: string): void {
      delete data[key];
    },
    key(index: number): string | null {
      return Object.keys(data)[index] ?? null;
    },
    clear(): void {
      data = {};
    },
    get length(): number {
      return Object.keys(data).length;
    },
  };
};

export default createMemoryStorage;
